var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-update-item.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showMoveToCart")) {
output += "\n    ";
output += "\n    ";
var t_1;
t_1 = "c-button-secondary c-product-update-item__button--secondary";
frame.set("buttonStyle", t_1, true);
if(frame.topLevel) {
context.setVariable("buttonStyle", t_1);
}
if(frame.topLevel) {
context.addExport("buttonStyle", t_1);
}
output += "\n";
;
}
else {
output += "\n    ";
var t_2;
t_2 = "c-button-primary c-product-update-item__button";
frame.set("buttonStyle", t_2, true);
if(frame.topLevel) {
context.setVariable("buttonStyle", t_2);
}
if(frame.topLevel) {
context.addExport("buttonStyle", t_2);
}
output += "\n";
;
}
output += "\n\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToCart")),"canAddToCart")) {
var t_3;
t_3 = "";
frame.set("disabled", t_3, true);
if(frame.topLevel) {
context.setVariable("disabled", t_3);
}
if(frame.topLevel) {
context.addExport("disabled", t_3);
}
output += "\n";
;
}
else {
output += "\n    ";
var t_4;
t_4 = "disabled";
frame.set("disabled", t_4, true);
if(frame.topLevel) {
context.setVariable("disabled", t_4);
}
if(frame.topLevel) {
context.addExport("disabled", t_4);
}
output += "\n";
;
}
output += "<span class=\"dom-update-item\">\n    <button type=\"button\" ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "disabled"), env.opts.autoescape);
output += "  class=\"js-update-item ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "buttonStyle"), env.opts.autoescape);
output += " c-product-update-item__button\" aria-controls=\"a-update-item-confirm\" data-qa-update-item>\n\n        <span class=\"js-update-item-text c-product-update-item__text\">";
output += runtime.suppressValue((lineno = 18, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_update-item"])), env.opts.autoescape);
output += "</span>\n\n    </button>\n</span>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-update-item.j2"] , dependencies)